import Firebase from 'firebase/app';
import credentials from './credentials';

require('firebase/database');

export const App = !Firebase.apps.length
    ? Firebase.initializeApp(credentials.config)
    : Firebase.app();
